/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RemoveAdminForBillingGroupMutationInput = {
    billingGroupId: string;
    clientMutationId?: string | null | undefined;
    forceDelete?: boolean | null | undefined;
    orgRelayId: string;
    userId: string;
};
export type RemoveAdminForBillingGroupMutationVariables = {
    input: RemoveAdminForBillingGroupMutationInput;
};
export type RemoveAdminForBillingGroupMutationResponse = {
    readonly removeAdminForBillingGroup: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RemoveAdminForBillingGroupMutation = {
    readonly response: RemoveAdminForBillingGroupMutationResponse;
    readonly variables: RemoveAdminForBillingGroupMutationVariables;
};



/*
mutation RemoveAdminForBillingGroupMutation(
  $input: RemoveAdminForBillingGroupMutationInput!
) {
  removeAdminForBillingGroup(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RemoveAdminForBillingGroupMutationPayload",
            "kind": "LinkedField",
            "name": "removeAdminForBillingGroup",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RemoveAdminForBillingGroupMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RemoveAdminForBillingGroupMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "9a110f4658a5b32f58371de44a1e4030",
            "id": null,
            "metadata": {},
            "name": "RemoveAdminForBillingGroupMutation",
            "operationKind": "mutation",
            "text": "mutation RemoveAdminForBillingGroupMutation(\n  $input: RemoveAdminForBillingGroupMutationInput!\n) {\n  removeAdminForBillingGroup(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '03d83c970a3dc0041df7a0dfffc19b7a';
export default node;
